// LLM generated - Model Claude 4 Sonnet

export const MESSAGE_PAGE_SIZE = 20;

export const CONTEST_CHAT_QUERY_KEYS = {
  LIVE_ACTIVITY_CHATS: 'liveActivityChats',

  LIVE_ACTIVITY_MESSAGES: 'liveActivityMessages',
  CHAT_MESSAGES: 'chatMessages',

  UNREAD_MESSAGES: 'unreadMessages',

  AVAILABLE_REACTIONS: 'availableReactions',
  MESSAGE_REACTIONS: 'messageReactions',

  CHAT_USER_SETTINGS: 'chatUserSettings',
} as const;

export const createQueryKey = {
  liveActivityChats: (contestId: string) => [
    CONTEST_CHAT_QUERY_KEYS.LIVE_ACTIVITY_CHATS,
    contestId,
  ],

  liveActivityMessages: (chatId: string) => [
    CONTEST_CHAT_QUERY_KEYS.LIVE_ACTIVITY_MESSAGES,
    chatId,
  ],

  chatMessages: (chatId: string, pageSize?: number, reversePageOrder?: boolean) => [
    CONTEST_CHAT_QUERY_KEYS.CHAT_MESSAGES,
    chatId,
    pageSize,
    reversePageOrder,
  ],

  unreadMessages: (chatId: string) => [CONTEST_CHAT_QUERY_KEYS.UNREAD_MESSAGES, chatId],

  availableReactions: () => [CONTEST_CHAT_QUERY_KEYS.AVAILABLE_REACTIONS],

  messageReactions: (chatId: string, messageId: string) => [
    CONTEST_CHAT_QUERY_KEYS.MESSAGE_REACTIONS,
    chatId,
    messageId,
  ],

  chatUserSettings: (chatId: string) => [CONTEST_CHAT_QUERY_KEYS.CHAT_USER_SETTINGS, chatId],
} as const;
